export default "__VITE_ASSET__BCE64mHe__"